module.exports = __webpack_public_path__ + "img/ck.ck85e3a69.svg";